<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：物品类型列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleResTypeSelect('')"
              :class="{ 'selected': housekeepingResourceManageInfo.conditions.resTypeId === '' }">
              全部
            </li>
            <li v-for="(item, index) in housekeepingResourceManageInfo.resourceStoreTypes" :key="index"
              @click="handleResTypeSelect(item.rstId)"
              :class="{ 'selected': housekeepingResourceManageInfo.conditions.resTypeId === item.rstId }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('housekeepingResource.queryCondition') }}</div>
            <div class="ibox-tools" style="top:10px;"></div>
          </div>
          <div class="">
            <el-form :inline="true" :model="housekeepingResourceManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="housekeepingResourceManageInfo.conditions.resName"
                    :placeholder="$t('housekeepingResource.inputResourceName')"></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input v-model="housekeepingResourceManageInfo.conditions.supplierName"
                    :placeholder="$t('housekeepingResource.inputSupplierName')"></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryHousekeepingResourceMethod">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetHousekeepingResourceMethod">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 服务资源表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('housekeepingResource.serviceResource') }}</div>
            <div class="ibox-tools" style="top:10px;">
              <el-button type="primary" size="small" @click="_openAddHousekeepingResourceModal">
                <i class="el-icon-plus"></i> {{ $t('common.add') }}
              </el-button>
            </div>
          </div>
          <div class="">
            <el-table :data="housekeepingResourceManageInfo.housekeepingResources" border style="width:100%">
          <el-table-column prop="resTypeName" :label="$t('housekeepingResource.typeName')"
            align="center"></el-table-column>
          <el-table-column prop="resName" :label="$t('housekeepingResource.resourceName')"
            align="center"></el-table-column>
          <el-table-column prop="resCode" :label="$t('housekeepingResource.resourceCode')"
            align="center"></el-table-column>
          <el-table-column prop="costPrice" :label="$t('housekeepingResource.costPrice')"
            align="center"></el-table-column>
          <el-table-column prop="price" :label="$t('housekeepingResource.salePrice')" align="center"></el-table-column>
          <el-table-column prop="stock" :label="$t('housekeepingResource.stock')" align="center"></el-table-column>
          <el-table-column prop="supplierName" :label="$t('housekeepingResource.supplierName')"
            align="center"></el-table-column>
          <el-table-column prop="remark" :label="$t('housekeepingResource.description')"
            align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_openEditHousekeepingResourceModel(scope.row)">{{ $t('common.edit')
                  }}</el-button>
                <el-button size="mini" @click="_openDeleteHousekeepingResourceModel(scope.row)">{{ $t('common.delete')
                  }}</el-button>
                <el-button size="mini" v-if="scope.row.configId" @click="_openhousekeepingFeeConfigManage(scope.row)">{{
                  $t('housekeepingResource.fee') }}</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="housekeepingResourceManageInfo.total">            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-housekeeping-resource ref="addHousekeepingResource" @refresh="_listHousekeepingResources"></add-housekeeping-resource>
    <edit-housekeeping-resource ref="editHousekeepingResource" @refresh="_listHousekeepingResources"></edit-housekeeping-resource>
    <delete-housekeeping-resource ref="deleteHousekeepingResource" @refresh="_listHousekeepingResources"></delete-housekeeping-resource>
  </div>
</template>

<script>
import { queryHousekeepingResource, listResourceStoreTypes } from '@/api/housekeepingResource/housekeepingResourceApi'
import AddHousekeepingResource from '@/components/housekeepingResourceManage/addHousekeepingResource'
import EditHousekeepingResource from '@/components/housekeepingResourceManage/editHousekeepingResource'
import DeleteHousekeepingResource from '@/components/housekeepingResourceManage/deleteHousekeepingResource'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'HousekeepingResourceManage',
  components: {
    AddHousekeepingResource,
    EditHousekeepingResource,
    DeleteHousekeepingResource
  },
  data() {
    return {
      housekeepingResourceManageInfo: {
        housekeepingResources: [],
        total: 0,
        records: 1,
        moreCondition: false,
        resId: '',
        resourceStoreTypes: [],
        conditions: {
          resTypeId: '',
          resTypeName: '',
          resName: '',
          supplierName: '',
          shopId: getShopId(),
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listHousekeepingResources()
    this._listResourceStoreTypes()
  },
  methods: {
    async _listHousekeepingResources() {
      try {
        const res = await queryHousekeepingResource(this.housekeepingResourceManageInfo.conditions)
        this.housekeepingResourceManageInfo.housekeepingResources = res.data
        this.housekeepingResourceManageInfo.total = res.total
        this.housekeepingResourceManageInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    async _listResourceStoreTypes() {
      try {
        const res = await listResourceStoreTypes({
          page: 1,
          row: 50,
          shopId: getShopId()
        })
        this.housekeepingResourceManageInfo.resourceStoreTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    _openAddHousekeepingResourceModal() {
      this.$refs.addHousekeepingResource.open()
    },
    _openEditHousekeepingResourceModel(row) {
      this.$refs.editHousekeepingResource.open(row)
    },
    _openDeleteHousekeepingResourceModel(row) {
      this.$refs.deleteHousekeepingResource.open(row)
    },
    _queryHousekeepingResourceMethod() {
      this.housekeepingResourceManageInfo.conditions.page = 1
      this._listHousekeepingResources()
    },
    _resetHousekeepingResourceMethod() {
      this.housekeepingResourceManageInfo.conditions = {
        resTypeId: '',
        resName: '',
        supplierName: '',
        shopId: getShopId(),
        page: 1,
        row: 10
      }
      this._listHousekeepingResources()
    },
    _openhousekeepingFeeConfigManage(row) {
      this.$router.push(`/pages/housekeeping/housekeepingFeeConfigManage?configId=${row.configId}`)
    },
    handleSizeChange(val) {
      this.housekeepingResourceManageInfo.conditions.row = val
      this._listHousekeepingResources()
    },
    handleCurrentChange(val) {
      this.housekeepingResourceManageInfo.conditions.page = val
      this._listHousekeepingResources()
    },
    handleResTypeSelect(resTypeId) {
      this.housekeepingResourceManageInfo.conditions.resTypeId = resTypeId
      this.housekeepingResourceManageInfo.conditions.page = 1
      this._listHousekeepingResources()
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}

/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>